module.exports = __webpack_public_path__ + "img/foreword.088b0bff.jpg";